<div class="row Slider">
  <div class="col">

    <div id="Slider" class="carousel slide" data-ride="carousel">

      <div class="carousel-inner rounded-3 border shadow-sm">
        <div class="carousel-item active">
          <img src="Public/Img/bannerWeb/banner1.jpg" alt="Flauta Transversal" loading="eager" fetchpriority="high" decoding="async">
        </div>
        <div class="carousel-item">
          <img src="Public/Img/bannerWeb/banner2.jpg" alt="Saxofon Soprano" loading="lazy" decoding="async">
        </div>
      </div>

    </div>
  </div>

</div>

<div class="row my-4 home-categories">
  <div class="col-6 col-sm-4 col-lg-2 my-1">
    <div class="card">
      <a [routerLink]="categoryPath(6)">
        <img class="card-img-top" src="Public/Img/BtnSax.jpg" alt="Saxofones" loading="lazy" decoding="async">
        <div class="card-body">
          <p class="CardLink card-text text-center"> Saxofón </p>
        </div>
      </a>
    </div>
  </div>
  <div class="col-6 col-sm-4 col-lg-2 my-1">
    <div class="card">
      <a [routerLink]="categoryPath(7)">
        <img class="card-img-top" src="Public/Img/BtnClr.jpg" alt="Clarinetes" loading="lazy" decoding="async">
        <div class="card-body">
          <p class="CardLink card-text text-center"> Clarinete </p>
        </div>
      </a>
    </div>
  </div>
  <div class="col-6 col-sm-4 col-lg-2 my-1">
    <div class="card">
      <a [routerLink]="categoryPath(14)">
        <img class="card-img-top" src="Public/Img/BtnTrm.jpg" alt="Trompetas" loading="lazy" decoding="async">
        <div class="card-body">
          <p class="CardLink card-text text-center"> Trompeta </p>
        </div>
      </a>
    </div>
  </div>
  <div class="col-6 col-sm-4 col-lg-2 my-1">
    <div class="card">
      <a [routerLink]="categoryPath(15)">
        <img class="card-img-top" src="Public/Img/BtnTrb.jpg" alt="Trombones" loading="lazy" decoding="async">
        <div class="card-body">
          <p class="CardLink card-text text-center"> Trombón </p>
        </div>
      </a>
    </div>
  </div>
  <div class="col-6 col-sm-4 col-lg-2 my-1">
    <div class="card">
      <a [routerLink]="categoryPath(8)">
        <img class="card-img-top" src="Public/Img/BtnFlt.jpg" alt="Flautas" loading="lazy" decoding="async">
        <div class="card-body">
          <p class="CardLink card-text text-center"> Flauta </p>
        </div>
      </a>
    </div>
  </div>
  <div class="col-6 col-sm-4 col-lg-2 my-1">
    <div class="card">
      <a [routerLink]="categoryPath(111)">
        <img class="card-img-top" src="Public/Img/BtnCDb.jpg" alt="Cañas Dobles" loading="lazy" decoding="async">
        <div class="card-body">
          <p class="CardLink card-text text-center"> Cañas Dobles </p>
        </div>
      </a>
    </div>
  </div>
</div>


<div class="row Novedades">

  <div class="col-12 p-0 TitleSec">
    <div>
      <h3> Novedades </h3>
    </div>
  </div>
  @for (lt of lsProdNov; track lt; let i = $index) {
    <div class="col-md-3 col-sm-6">
      <div class="ProductGrid">
        <div class="ProductImage">
          <a [routerLink]="productPath(lt)">
            <img class="pic-1" [src]="productImageUrl(lt)" [alt]="lt.Nombre" [attr.loading]="i < 4 ? 'eager' : 'lazy'" decoding="async"> </a>
          </div>
          <div class="ProductContent">
            <div class="Mark"> {{lt.Marca}} </div>
            <h3 class="Title"><a [routerLink]="productPath(lt)">{{lt.Nombre}}</a></h3>
            <div class="Price">{{ lt.Modelos[0].Precio | money }}</div>
          </div>
          <ul class="Social">
            <li>
              <a [routerLink]="productPath(lt)" data-tip="Ver Producto">
                <i class='bx bx-search'></i>
              </a>
            </li>
            <li>
              <a href="" data-tip="Agregar a Favoritos">
                <i class='bx bx-heart'></i>
              </a>
            </li>
          </ul>
        </div>
      </div>
    }


  </div>
  <div class="row Recomendaciones">

    <div class="col-12 p-0 TitleSec">
      <div>
        <h3> Recomendaciones </h3>
      </div>
    </div>
    @for (lt of lsProdRec; track lt; let i = $index) {
      <div class="col-md-3 col-sm-6">
        <div class="ProductGrid">
          <div class="ProductImage">
            <a [routerLink]="productPath(lt)"> <img class="pic-1" [src]="productImageUrl(lt)" [alt]="lt.Nombre" loading="lazy" decoding="async"> </a>
            </div>
            <div class="ProductContent">
              <div class="Mark"> {{lt.Marca}} </div>
              <h3 class="Title"><a [routerLink]="productPath(lt)">{{lt.Nombre}}</a></h3>
              <div class="Price">{{ lt.Modelos[0].Precio | money }}</div>
            </div>
            <ul class="Social">
              <li>
                <a [routerLink]="productPath(lt)" data-tip="Ver Producto">
                  <i class='bx bx-search'></i>
                </a>
              </li>
              <li>
                <a href="" data-tip="Agregar a Favoritos">
                  <i class='bx bx-heart'></i>
                </a>
              </li>
            </ul>
          </div>
        </div>
      }


    </div>

    <div class="row Marcas">

      <div class="col-12 p-0 TitleSec">
        <div>
          <h3> Marcas </h3>
        </div>
      </div>

      <div class="col-6 col-md-3 my-3 d-flex justify-content-center">
        <img alt="Vandoren" src="./Public/Img/Vandoren.png" class="img-fluid" loading="lazy" decoding="async">
      </div>
      <div class="col-6 col-md-3 my-3 d-flex justify-content-center">
        <img alt="BAM" src="./Public/Img/Bam.png" class="img-fluid" loading="lazy" decoding="async">
      </div>
      <div class="col-6 col-md-3 my-3 d-flex justify-content-center">
        <img alt="Yamaha" src="./Public/Img/Yamaha.png" class="img-fluid" loading="lazy" decoding="async">
      </div>
      <div class="col-6 col-md-3 my-3 d-flex justify-content-center">
        <img alt="Cora by L. America" src="./Public/Img/Cora.png" class="img-fluid" loading="lazy" decoding="async">
      </div>
    </div>

    <section class="row HelpCenter" aria-labelledby="help-center-title">
      <div class="col-12 p-0 TitleSec">
        <div>
          <h3 id="help-center-title">Centro de ayuda</h3>
        </div>
      </div>

      <div class="col-md-4" *ngFor="let item of faqItems">
        <article class="HelpCard">
          <h4>{{ item.question }}</h4>
          <p>{{ item.answer }}</p>
        </article>
      </div>
    </section>

    <div class="row Bottom">

      <div class="col-12 p-0 TitleSec">
        <div>
          <h3>Links de Interés </h3>
        </div>
      </div>

      <div class="col-sm-6 col-lg-3">
        <div class="InfoCard card card-cascade narrower">

          <!-- Card content -->
          <div class="NS card-body card-body-cascade">
            <div class="NewsL">
              <h5> NEWSLETTER </h5>
            </div>

            <form action="#">
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <span class="input-group-text">
                    <i class='bx bx-user'></i>
                  </span>
                </div>
                <input type="text" class="form-control" placeholder="Nombre">
              </div>
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <span class="input-group-text">
                    <i class='bx bx-at'></i>
                  </span>
                </div>
                <input type="text" class="form-control" placeholder="Correo">
              </div>
              <div class="form-check">
                <input type="checkbox" id="ChkTrm" class="form-check-input">
                <label for="ChkTrm" class="form-check-label">He leído la política de privacidad y autorizo
                el tratamiento de mis datos.</label>
                <span></span>
              </div>
              <div class="form-group text-center">
                <button type="submit" class="btn btn-outline-dark">
                  Enviar
                </button>
              </div>
            </form>

          </div>

        </div>
      </div>

      <div class="col-sm-6 col-lg-3">
        <div class="InfoCard card card-cascade narrower">

          <!-- Card content -->
          <div class="card-body card-body-cascade">
            <!-- Title -->
            <h5 class="card-title"> SERVICIO AL CLIENTE </h5>
            <!-- Text -->
            <div class="card-text">
              <div class="Ft"> <a [routerLink]="['ordenar']" class="FtLink"> ¿Cómo ordenar? </a> </div>
              <div class="Ft"> <a href="#" class="FtLink"> Rastreo de órdenes </a> </div>
              <div class="Ft"> <a href="#" class="FtLink"> Cambios y devoluciones </a> </div>
            </div>
          </div>

        </div>
      </div>

      <div class="col-sm-6 col-lg-3">
        <div class="InfoCard card card-cascade narrower">

          <!-- Card content -->
          <div class="card-body card-body-cascade">
            <!-- Title -->
            <h5 class="card-title"> INFORMACIÓN </h5>
            <!-- Text -->
            <div class="card-text">
              <div class="Ft"> <a [routerLink]="['nosotros']" class="FtLink"> ¿Quiénes somos? </a> </div>
              <div class="Ft"> <a [routerLink]="['bandas']" class="FtLink"> Bandas sinfónicas y educación
              </a> </div>
              <div class="Ft"> <a [routerLink]="['politicas']" class="FtLink"> Políticas de envío </a></div>
              <div class="Ft"> <a [routerLink]="['privacidad']" class="FtLink"> Términos y privacidad </a>
            </div>
          </div>
        </div>

      </div>
    </div>

    <div class="col-sm-6 col-lg-3">
      <div class="InfoCard card card-cascade narrower">

        <!-- Card content -->
        <div class="card-body card-body-cascade">
          <!-- Title -->
          <h5 class="card-title"> MÉTODOS DE PAGO </h5>
          <!-- Text -->
          <div class="card-text">
            <div class="FtPay"> MasterCard, Visa, Carnet </div>
            <div class="FtPay"> American Express, Walmart </div>
            <div class="FtPay"> 7 Eleven, Sams Club </div>
            <div class="FtPay"> Farmacias del Ahorro </div>
            <div class="FtPay"> Superama, Bodega Aurrera </div>
            <div class="FtPay"> Farmacia Guadalajara </div>
            <div class="FtPay"> Extra </div>
          </div>
        </div>

      </div>
    </div>
  </div>
